import ShirtsAndTops from "./ShirtsAndTops";

function Women(){
    return(
        <div>
            <ShirtsAndTops/>
        </div>
    )
}
export default Women;